import { gql } from '@apollo/client';

export const GET_FOUND_ANIMALS = gql`
  query GetFoundAnimals($userLocation: [Float!]!, $radiusInKm: Float!) {
    getFoundAnimals(userLocation: $userLocation, radiusInKm: $radiusInKm) {
      _id
      userId
      contactName
      contactPhone
      contactEmail
      location {
        type
        coordinates
      }
      animalName
      animalType
      animalImageUrl
      breed
      colorMarkings
      dateFound
      sex
      foundNear
      estimatedWeight
      createdAt
      updatedAt
      reunited
    }
  }
`;

export const GET_FOUND_ANIMAL = gql`
  query GetFoundAnimal($_id: ID!) {
    getFoundAnimal(_id: $_id) {
      _id
      userId
      contactName
      contactPhone
      contactEmail
      location {
        type
        coordinates
      }
      animalName
      animalType
      animalImageUrl
      breed
      colorMarkings
      dateFound
      sex
      foundNear
      estimatedWeight
      createdAt
      updatedAt
      reunited
      language
      expiresAt
      extensionCount
      lastExtendedAt
    }
  }
`;